<img *ngIf="src && !isDefaultImage; else doPlaceholder" [src]="src | appBaseUrl: 'assets'" alt="avatar" class="image" />
<ng-template #doPlaceholder>
  <div class="placeholder">{{ placeholder }}</div>
</ng-template>
